import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";


export const concierge = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】 | 整理収納アドバイザー派遣サービス';
	
	let btn_navy = {
		width: "50%",
		background: "#403E80",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "18px",
		textAlign: "center",
		padding: "15px",
		webkitTransition: "all 0.3s", 
	};

	let howto_apply_case = {
    paddinghouottom: "60px",
    marginBottom: "60px",
    borderBottom: "dotted #999",
		paddingBottom: "60px",
	};

	let overview_kome = {
		textAlign: "left",
		color: "#333333",
		fontSize: "14px",
		marginTop: "40px",
		padding: "0 200px",
	};
	if (window.matchMedia( "(max-width: 800px)").matches) {
		overview_kome = {
			textAlign: "left",
			color: "#333333",
			fontSize: "14px",
			marginTop: "40px",
			lineHeight: "1.5",
		};
	}


	let service_area_map = {
		margin: "40px 0",
	};
	if (window.matchMedia( "(max-width: 800px)").matches) {
		service_area_map = {
			margin: "40px 0",
			textAlign: "center",
		};
	}

	let service_area_map_img = {
		width: "333px",
	};
	if (window.matchMedia( "(max-width: 800px)").matches) {
		service_area_map_img = {
			width: "70%",
		};
	}


	let howto_tel_text = {
		marginTop: "60px",
	};
	if (window.matchMedia( "(max-width: 800px)").matches) {
		howto_tel_text = {
			marginTop: "0px",
		};
	}

	let title_text = {
		color: "#333333",
	};



  return ( 
		<div>		
			<div className="contents">
					
					<div id="firstview" className="firstview">
							<div className="firstview-img">
									<h1><img className="pc-show" src="resource/img/static/concierge/main-visual.png?20230419" alt="整理収納アドバイザー派遣サービス"/></h1>
									<h1><img className="sp-show" src="resource/img/static/concierge/main-visual_sp.png?20230419" alt="整理収納アドバイザー派遣サービス"/></h1>
							</div>
					</div>

					<section id="concierge" className="concierge">
							
							<div className="container">
									<h2 className=""><img src="resource/img/static/concierge/service-title.svg" alt="整理収納アドバイザー派遣サービス"/></h2>
									<h4 style={title_text}>お客さまの性格やライフスタイル、家族構成を分析して、<br className="pc-br"/>一人一人のお客さまにご満足いただけるお片付けをご提案しています。</h4>
							</div>
						
					</section>
					<section id="price" className="price">
							
							<div className="container">
									<div className="row">
											<div className="col-lg-4">
													<div className="price_img"><img src="resource/img/static/concierge/price_img.png?20230419" alt=""/></div>
											</div>
											<div className="col-lg-8">
													<div className=""><img src="resource/img/static/concierge/price_text.svg?20230501" alt=""/></div>
											</div>
											<div className="col-12">
													<p className="search-btn"><a className="btn" style={btn_navy} href="/list/" role="button">物件を探す</a></p>
													<p className="price-kome">※ページ下部注意事項をご一読の上お申し込みください。</p>
											</div>
									</div>
								
							</div>
							
					</section>
					<section id="case" className="case">
            <div className="container">
                <h3 className=""><img src="resource/img/static/concierge/case-title.svg" alt="お片付け事例"/></h3>
                <div className="row case-row">
                    <div className="col-lg-5">
                        <p className="case-title"><img src="resource/img/static/concierge/case1-title.svg" alt="case1"/></p>
                        <p className="case-text">対象者：夫婦＋お子様3人</p>
                        <p className="case-text">場所　：キッチン</p>
                        <p className="case-text">悩み　：子どもが3人いる中仕事もしているため片付けられない。使いやすいキッチンに整えたい。</p>
                        <p className="case-text">解決法：カウンターや作業台の上にモノを置いてしまう。何もモノを置かないキッチンにしたい。</p>
                    </div>
                    <div className="col-lg-7">
                        <p><img src="resource/img/static/concierge/case1-img.png" alt="case1-before-after"/></p>
                    </div>
                </div>
                <div className="row case-row">
                    <div className="col-lg-5">
                        <p className="case-title"><img src="resource/img/static/concierge/case2-title.svg" alt="case2"/></p>
                        <p className="case-text">対象者：夫婦（共働き）</p>
                        <p className="case-text">場所　：リビング</p>
                        <p className="case-text">悩み　：お互い仕事に追われてリビングが散らかってしまう。リラックスできるリビングにしたい。</p>
                        <p className="case-text">解決法：普段使っていないモノを処分し、定位置を決めて出しっぱなしをなくす。</p>
                    </div>
                    <div className="col-lg-7">
                        <p><img src="resource/img/static/concierge/case2-img.png" alt="case2-before-after"/></p>
                    </div>
                </div>
                <div className="row case-row">
                    <div className="col-lg-5">
                        <p className="case-title"><img src="resource/img/static/concierge/case3-title.svg" alt="case3"/></p>
                        <p className="case-text">対象者：夫婦＋お子様1人</p>
                        <p className="case-text">場所　：洗面所</p>
                        <p className="case-text">悩み　：すぐにごちゃごちゃしてしまう洗面台。オープン扉なのでスッキリ見せたい。</p>
                        <p className="case-text">解決法：ボトルとタオルを揃えてスッキリと。引き出しの中も整理してドライヤーなども収納できた。</p>
                    </div>
                    <div className="col-lg-7">
                        <p><img src="resource/img/static/concierge/case3-img.png" alt="case3-before-after"/></p>
                    </div>
                </div>
                <div className="row case-row">
                    <div className="col-lg-5">
                        <p className="case-title"><img src="resource/img/static/concierge/case4-title.svg" alt="case4"/></p>
                        <p className="case-text">対象者：1人暮らし</p>
                        <p className="case-text">場所　：ウォークインクローゼット</p>
                        <p className="case-text">悩み　：引越しでより広いクローゼットがある部屋に引っ越したが、ひとまず服を収めたため雑多な印象。</p>
                        <p className="case-text">解決法：ラックや収納ケースを活用して整理。</p>
                    </div>
                    <div className="col-lg-7">
                        <p><img src="resource/img/static/concierge/case4-img.png" alt="case4-before-after"/></p>
                    </div>
                </div>
            </div>
        	</section>
					<section id="overview" className="overview">
						
							<div className="container">
									<div className="row">
											<div className="col-12">
													<h3 className=""><img src="resource/img/static/concierge/overview-title.svg" alt="サービス概要"/></h3>
											</div>
											<div className="col-12 offset-lg-1 col-lg-10">
													<div className=""><img src="resource/img/static/concierge/overview-text.svg?20230501" alt=""/></div>
											</div>
											<div className="col-12">
													<p style={overview_kome}>※交通費が別途1,300円（1名）かかります。<br className="br-sp"/>※土日祝日は上記料金の10%増になります。<br/>
													※個人のお客様向けの料金を表示しております。<br className="br-sp"/>　法人のお客様でご利用検討の場合は、<br/>
													　スタッフ2名3時間49,302円（税込）～承ります。（通常は3時間54,780円です。）<br/>
													　交通費は別途2,600円かかります。
													</p>
											</div>
									</div>
									
							</div>
							
					</section>
					<section id="service-area" className="service-area">
						
							<div className="container">
									<div className="row">
											<div className="col-12 offset-lg-1 col-lg-10">
													<h3><img src="resource/img/static/concierge/area-title.svg" alt="ご利用可能エリア"/></h3>
													<h4><img src="resource/img/static/concierge/area-text.svg" alt="青山一丁目駅から1.5時間以内の1都3県"/></h4>
											</div>
											<div className="col-12 offset-lg-1 col-lg-10">
													<p style={service_area_map}><img src="resource/img/static/concierge/area-map.svg" alt="青山一丁目駅から1.5時間以内" style={service_area_map_img}/></p>
													<p className="service-area-text2"><img src="resource/img/static/concierge/area-text2.svg" alt="・提供場所が青山一丁目駅から1.5時間を超える場所にある場合、お申込みをお受けできかねます。"/></p>
													<p className="service-area-kome">※ご契約のトランクルーム又は、ご自宅に整理収納アドバイザーがお伺いいたします。<br/>サービスご契約時に担当者にお伝えください。</p>
											</div>
									</div>
									
							</div>
							
					</section>
					<section id="howto-apply" className="howto-apply">
							
							<div className="container">
									<div className="row">
											<div className="col-12 offset-lg-1 col-lg-10">
													<h3><img src="resource/img/static/concierge/howto-apply-title.svg" alt="申し込み方法"/></h3>
													<h4><img src="resource/img/static/concierge/howto-apply-text.svg" alt="トランクルーム物件を新規契約の際にお申し込みください。"/></h4>
											</div>
									</div>
									
									<div className="row" style={howto_apply_case}>
											<div className="col-12 col-lg-4">
													<p className="howto-net pc-show"><img src="resource/img/static/concierge/howto-net.svg" alt="ネットで申し込み"/></p>
													<p className="howto-net sp-show"><img src="resource/img/static/concierge/howto-net_sp.svg" alt="ネットで申し込み"/></p>
											</div>
											<div className="col-12 col-lg-8">
													<p className="howto-net-text"><img src="resource/img/static/concierge/howto-net-text.svg" alt="契約内容の確認画面にて、「お片付けコンシェルジュ申込」 をお選びいただき、ご契約へと進んでください。"/></p>
													<p className="howto-net-img"><img src="resource/img/static/concierge/howto-net-img.png" alt="契約内容の確認画面"/></p>
											</div>
									</div>
									
									<div className="row">
											<div className="col-12 col-lg-4">
													<p className="howto-tel pc-show"><img src="resource/img/static/concierge/howto-tel.svg" alt="お電話で申し込み"/></p>
													<p className="howto-tel sp-show"><img src="resource/img/static/concierge/howto-tel_sp.svg" alt="お電話で申し込み"/></p>
											</div>
											<div className="col-12 col-lg-8">
													<p style={howto_tel_text}><img src="resource/img/static/concierge/howto-tel-text.svg" alt="オペレーターに「お片付けコンシェルジュ申込希望」とお伝えください。"/></p>
											</div>
									</div>
								
									<div className="row">
											<div className="col-12 offset-lg-1 col-lg-10">
													<p className="howto-apply-kome">ハローストレージ契約完了後に、ご登録いただいたメールアドレス宛に<br/>日程の希望をお伺いするメールをお送りしますので、そこから日程の希望をご返信ください。</p>
													<p className="search-btn"><a className="btn" style={btn_navy} href="/list/" role="button">物件を探す</a></p>
											</div>
									</div>
									
									<div className="row howto-notes">
											<div className="col-12">
													<p className="howto-notes-title">【注意事項】</p>
													<ul className="howto-notes-ul">
															<li>・それぞれの料金には収納グッズなどの金額は含まれません。グッズは実費となります。</li>
															<li>・ご訪問の際に、100円グッズを数点持参させていただきます。 当日そのままご購入いただけるようであれば、1点150円にて販売しております。（その際、グッズのお支払いは現金となります）
															</li>
															<li>・スタッフは全て女性のため、男性のお1人暮らし（または当日男性の方のみ在宅）の場合はスタッフ2名のコースでお伺いさせていただいております。</li>
															<li>・本サービスは家事代行とは異なります。ゴミ捨てや掃除代行は行っておりません。</li>
															<li>・作業実施日にはお申込日から平日で数えて10日目以降をご希望ください。それに則りご希望日程を頂戴してから3営業日以内にインブルーム株式会社より日程調整のご連絡をいたします（土日祝除く）</li>
															<li>・お申込み後に日程希望をお伺いするメールをお送り（またはお電話）いたします。</li>
															<li>・日程が確定後、ご訪問日の3日前までに担当コンシェルジュよりご挨拶のお電話をいたします。</li>
															<li>・屋外やコンテナでの作業は対象外です。</li>
															<li>・今回の10%割引の適用は、お片付けコンシェルジュのご利用がはじめての方限定となります。</li>
															<li>・キャンセルポリシーについては、お申込み後に送付されるフォームをご確認ください。</li>
													</ul>
											</div>
									</div>
									
							</div>
							
					</section>
			</div>
		
			<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z" crossorigin="anonymous"></link>	
			<script src="https://code.jquery.com/jquery-3.5.1.slim.min.js" integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj" crossorigin="anonymous"></script>
			<script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js" integrity="sha384-9/reFTGAW83EW2RDu2S0VKaIzap3H66lZH81PoYlFhbGU+6BZp6G7niu735Sk7lN" crossorigin="anonymous"></script>
			<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js" integrity="sha384-B4gt1jrGC7Jh4AgTPSdUtOBvfO8shuf57BaghqFfPlYxofvL8/KUEfYiJOMMV+rV" crossorigin="anonymous"></script>
			
		</div> 

  );
};



// WEBPACK FOOTER //
// ./pages/static/concierge.jsx